var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroFifthIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 65,
    viewBox: "0 0 76 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0442 33.2471L56.4671 51.7421C60.6203 46.7269 63.094 40.282 63.094 33.2471H34.0442Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2685 48.2476L34.0442 33.2246L18.8838 51.3112C22.9916 54.7379 28.2797 56.8257 34.0442 56.8257C41.3748 56.8257 47.9337 53.4897 52.2685 48.2249V48.2476Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4299 33.2471C18.4299 33.4286 18.4072 33.5874 18.4072 33.769C18.4072 38.4665 20.4952 42.6648 23.7633 45.5241L34.0443 33.2471H18.4299Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0443 8.69336C20.4952 8.69336 9.48804 19.677 9.48804 33.2476H34.0443V8.69336Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0442 1V33.2473H66.2941C66.2941 15.433 51.8599 1 34.0442 1Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1804 17.1119L61.8684 5.4248H75.5764",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5765 1H68.4502",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2286 51.7197L27.4172 63.7473H6.06104",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06104 59.1631H12.8242",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3774 17.7026L16.932 8.69336H1",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.60938H9.5107",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFifthIcon02);
export default __webpack_public_path__ + "static/media/intro_fifth_icon_02.0fccfc43d789c58c395e240cf9b793c1.svg";
export { ForwardRef as ReactComponent };